// This file is used to register the service worker
// It's automatically called by the PWA plugin
// No need to manually call this function

export function registerSW() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const baseEnv = (import.meta as unknown as { env: { BASE_URL?: string } }).env;
      const base = (baseEnv?.BASE_URL && baseEnv.BASE_URL.length > 0) ? baseEnv.BASE_URL : '/';
      const swUrl = `${base}sw.js`;
      navigator.serviceWorker.register(swUrl, { scope: base }).then(
        (registration) => {
          console.log('ServiceWorker registration successful with scope: ', registration.scope);
          // Check for updates periodically (every hour)
          setInterval(() => {
            registration.update().catch(err => 
              console.log('Error checking for updates: ', err));
          }, 60 * 60 * 1000);
        },
        (err) => {
          console.log('ServiceWorker registration failed: ', err);
        }
      );
    });
  }
}

// Listen for the 'beforeinstallprompt' event to prevent the default install prompt
// This is to avoid showing the install button, as per user's request
declare global {
  interface WindowEventMap {
    'beforeinstallprompt': BeforeInstallPromptEvent;
  }
  interface BeforeInstallPromptEvent extends Event {
    readonly platforms: string[];
    readonly userChoice: Promise<{
      outcome: 'accepted' | 'dismissed';
      platform: string;
    }>;
    prompt(): Promise<void>;
  }
}

// Prevent the default install prompt
window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  e.preventDefault();
  // Optionally, you can store the event to trigger it later
  // window.deferredPrompt = e;
  return false;
});
